/**
 * Flux Application Dispatcher.
 * Create an instance for using with a new Flux app.
 */
import _ from 'lodash';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import Dispatcher from 'js/vendor/Dispatcher';

type Action = {
  type: string;
  [key: string]: $TSFixMe;
};

export interface DispatcherInterface {
  register: (payload: $TSFixMe) => $TSFixMe;
  waitFor: (ids: string[]) => void;
}

export interface AppDispatcherInterface extends DispatcherInterface {
  new (): this;
  handleServerAction: (action: Action) => void;
  handleViewAction: (action: Action) => void;
}

// @ts-expect-error FIXME: write better types for AppDispatcher. Convert it to the class maybe?
const AppDispatcher: AppDispatcherInterface = function () {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  Dispatcher.call(this);
};

_.extend(AppDispatcher.prototype, Dispatcher.prototype);

AppDispatcher.prototype.handleServerAction = function (action: $TSFixMe) {
  this.dispatch({
    action,
    source: 'server',
  });
};

AppDispatcher.prototype.handleViewAction = function (action: $TSFixMe) {
  this.dispatch({
    action,
    source: 'view',
  });
};

export default AppDispatcher;
